import React, { useEffect, useState } from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const ContactBulkTagsModal = ({
  open,
  onClose,
  contactIds = [],
  onSuccess,
}) => {
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;

    const loadTags = async () => {
      try {
        const { data } = await api.get("/tags/list");
        setTags(data || []);
      } catch (err) {
        toastError(err);
      }
    };

    setSelectedTags([]);
    loadTags();
  }, [open]);

  const handleSubmit = async () => {
    if (!contactIds.length) {
      toast.warning(i18n.t("contacts.bulkTags.noContacts"));
      return;
    }

    if (!selectedTags.length) {
      toast.warning(i18n.t("contacts.bulkTags.noTags"));
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post("/contacts/bulk-tags", {
        contactIds,
        tags: selectedTags,
      });
      toast.success(
        data?.message || i18n.t("contacts.bulkTags.success")
      );
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{i18n.t("contacts.bulkTags.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {i18n.t("contacts.bulkTags.description")} ({contactIds.length})
        </Typography>
        <Autocomplete
          multiple
          size="small"
          options={tags}
          value={selectedTags}
          onChange={(_, value) => setSelectedTags(value)}
          getOptionLabel={(option) => option.name || ""}
          freeSolo
          filterSelectedOptions
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                style={{
                  backgroundColor: option.color || "#eee",
                  color: "white",
                  textShadow: "1px 1px 1px #000",
                }}
                label={option.name}
                {...getTagProps({ index })}
                size="small"
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={i18n.t("contacts.bulkTags.placeholder")}
              margin="dense"
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {i18n.t("confirmationModal.buttons.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading || !selectedTags.length}
        >
          {loading
            ? i18n.t("contacts.loading")
            : i18n.t("contacts.bulkTags.apply")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactBulkTagsModal;
